import { InfoTip } from './InfoTip';
import styles from './KPICard.module.css';

interface KPICardProps {
  label: string;
  value: string | number;
  sub?: string;
  color?: string;
  tooltip?: string;
}

export function KPICard({ label, value, sub, color, tooltip }: KPICardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.label}>{label}{tooltip && <InfoTip text={tooltip} />}</div>
      <div className={styles.value} style={color ? { color } : undefined}>
        {value}
      </div>
      {sub && <div className={styles.sub}>{sub}</div>}
    </div>
  );
}
